import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const linkFn = /* @__PURE__ */ createRecipe('link', {
  "size": "m",
  "weight": "bold",
  "variant": "unstyled"
}, [])

const linkVariantMap = {
  "color": [
    "danger"
  ],
  "variant": [
    "unstyled",
    "underlined"
  ],
  "weight": [
    "medium",
    "semibold",
    "bold"
  ],
  "size": [
    "xs",
    "s",
    "m",
    "l",
    "xl"
  ]
}

const linkVariantKeys = Object.keys(linkVariantMap)

export const link = /* @__PURE__ */ Object.assign(memo(linkFn.recipeFn), {
  __recipe__: true,
  __name__: 'link',
  __getCompoundVariantCss__: linkFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: linkVariantKeys,
  variantMap: linkVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, linkVariantKeys)
  },
  getVariantProps: linkFn.getVariantProps,
})